import { render, staticRenderFns } from "./PlayerChatBlockLink.vue?vue&type=template&id=26032958&"
import script from "./PlayerChatBlockLink.vue?vue&type=script&lang=js&"
export * from "./PlayerChatBlockLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports